import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientBiometricService = {
  getPatientBiometricsList(params){ return axiosRequest('GET', API_PATH.PATIENT_BIOMETRIC.LIST(params)) },
  getPatientBiometric(data){ return axiosRequest('POST', API_PATH.PATIENT_BIOMETRIC.INFO, data) },
  addPatientBiometric(data){ return axiosRequest('POST', API_PATH.PATIENT_BIOMETRIC.ADD, data) },
  deletePatientBiometric(data){ return axiosRequest('POST', API_PATH.PATIENT_BIOMETRIC.DELETE, data) },
  getPatientBiometricChartsData(params){ return axiosRequest('GET', API_PATH.PATIENT_BIOMETRIC.CHART(params)) },
}